import { render } from "./DropManagerPage.vue?vue&type=template&id=22355c2c&scoped=true"
import script from "./DropManagerPage.vue?vue&type=script&lang=js"
export * from "./DropManagerPage.vue?vue&type=script&lang=js"

import "./DropManagerPage.vue?vue&type=style&index=0&id=22355c2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22355c2c"]])

export default __exports__